// extracted by mini-css-extract-plugin
export default {"heading":"Sz-z","corrected":"Tz-z","redirectVerbiageContainer":"Uz-z","redirectVerbiageText":"Vz-z"};